import { ActividadesAdapters } from "../adapters/actividades.adapters"
import { useIntegraWeb } from "./noticias.services"

/**
 * Servei d'activitats disponibles del WS d'Activitats (adminactivitats).
 *
 * Igual que les notícies, és un servei EXTERN a la API del backoffice: es crida
 * amb `fetch` des del fetcher compartit `useIntegraWeb` i la resposta es
 * normalitza amb `ActividadesAdapters`.
 *
 * URL: {REACT_APP_WEB_SERVICE_ACTIVIDADES}/integraWeb.php?accion=obtener_actividades_disponibles&actividad=...&page=...
 */
const ActividadesServices = {

    GET_ACTIVIDADES: function () {

        return useIntegraWeb(ActividadesAdapters.GET_ACTIVIDADES)
    },

    GET_ACTIVIDAD: function () {

        return useIntegraWeb(ActividadesAdapters.GET_ACTIVIDAD)
    },

    // POST .../integraWeb.php  accion=inscribir_personas_actividad
    POST_INSCRIBIR_PERSONAS: function () {

        return useIntegraWeb(ActividadesAdapters.POST_INSCRIBIR_PERSONAS, { method: 'post' })
    },

    // POST .../integraWeb.php  accion=anular_inscripcion
    ANULAR_INSCRIPCION: function () {

        return useIntegraWeb(ActividadesAdapters.ANULAR_INSCRIPCION, { method: 'post' })
    },
}

export {
    ActividadesServices
}